import { render, staticRenderFns } from "./fixedSetMeal.vue?vue&type=template&id=2ebc3b64&scoped=true&"
import script from "./fixedSetMeal.vue?vue&type=script&lang=js&"
export * from "./fixedSetMeal.vue?vue&type=script&lang=js&"
import style0 from "./fixedSetMeal.vue?vue&type=style&index=0&id=2ebc3b64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc3b64",
  null
  
)

export default component.exports